(() => {
  if (customElements.get('store-visit-form')) return;
  customElements.define('store-visit-form', class extends HTMLElement {
    connectedCallback() { this.frame = requestAnimationFrame(() => this.init()); }
    init() {
      if (this.controller || !this.isConnected) return;
      const form = this.querySelector('form');
      if (!form) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const success = this.querySelector('[data-success-redirect]');
      if (success) {
        const url = new URL(success.href, location.href);
        if (['http:', 'https:'].includes(url.protocol) && url.href !== location.href) { location.assign(url.href); return; }
      }
      const state = form.elements.namedItem('Dropdown3');
      const city = form.elements.namedItem('Dropdown2');
      const store = form.elements.namedItem('Dropdown');
      const looking = form.elements.namedItem('Dropdown1');
      const normalize = value => String(value || '').replace(/^\s*Limelight\s+Lab\s+Grown\s+Diamonds\b\s*[-–—,:|]?\s*/i, '').replace(/\s+/g, ' ').trim().toLowerCase();
      let updateCity, updateStore;
      if (state && city && store && looking) {
        this.cityGroups ||= [...city.querySelectorAll('optgroup')].map(g => g.cloneNode(true));
        this.storeGroups ||= [...store.querySelectorAll('optgroup')].map(g => g.cloneNode(true));
        const fill = (select, groups, parent, label) => {
          const selected = select.value;
          const group = groups.find(g => g.label === parent);
          select.replaceChildren(new Option(label, ''));
          if (group) select.append(group.cloneNode(true));
          select.disabled = !group;
          if ([...select.options].some(o => o.value === selected)) select.value = selected;
        };
        updateStore = () => {
          fill(store, this.storeGroups, city.value, 'Select nearest store');
        };
        updateCity = () => { fill(city, this.cityGroups, state.value, 'Select city'); updateStore(); };
        state.addEventListener('change', () => { city.value = ''; store.value = ''; updateCity(); }, options);
        city.addEventListener('change', () => { store.value = ''; updateStore(); }, options);
        form.addEventListener('reset', () => { this.resetFrame = requestAnimationFrame(updateCity); }, options);
        form.addEventListener('submit', event => {
          if (!state.value || !city.value || !looking.value || !store.value) { event.preventDefault(); form.reportValidity(); }
        }, options);
        updateCity();
      }
      document.addEventListener('store-locator:visit', event => {
        if (!event.detail?.store) return;
        const requested = normalize(event.detail.store);
        const matches = option => { const value = normalize(option.value); return value && (value === requested || value.includes(requested) || requested.includes(value)); };
        const input = this.querySelector('[data-store-input]');
        const list = this.querySelector('[data-store-options]');
        if (input && list) { input.value = [...list.options].find(matches)?.value || event.detail.store; return; }
        if (!updateCity) return;
        const group = this.storeGroups.find(g => [...g.querySelectorAll('option')].some(matches));
        const option = group && [...group.querySelectorAll('option')].find(matches);
        const cityGroup = group && this.cityGroups.find(g => [...g.querySelectorAll('option')].some(o => o.value === group.label));
        if (!option || !cityGroup) return;
        state.value = cityGroup.label; city.value = ''; store.value = ''; updateCity();
        city.value = group.label; updateStore(); store.value = option.value;
      }, options);
      const params = new URLSearchParams(location.search);
      for (const name of ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'zc_gad']) {
        const input = form.elements.namedItem(name);
        if (input) input.value = params.get(name) || '';
      }
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame); cancelAnimationFrame(this.resetFrame);
      this.controller?.abort(); this.controller = null;
    }
  });
})();
